import { render } from "./Chat_Avatar.vue?vue&type=template&id=3eb0a358"
import script from "./Chat_Avatar.vue?vue&type=script&lang=js"
export * from "./Chat_Avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__